export default "__VITE_ASSET__BdYtXZBe__"